module.exports = function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
};



//////////////////
// WEBPACK FOOTER
// ./~/html-to-react/~/ramda/src/internal/_isObject.js
// module id = 653
// module chunks = 0